import React, { useEffect, useRef, useState } from 'react';
import { useLang } from '../../i18n/LanguageContext';
import { Link } from 'react-router-dom';
import { FaCheck } from 'react-icons/fa';

const PLANS = [
  {
    nameKey: 'landing.pricing.starterName',
    priceKey: 'landing.pricing.starterPrice',
    period: '',
    descKey: 'landing.pricing.starterDesc',
    color: '#1877f2',
    bg: '#fff',
    border: '#BFDBFE',
    checkColor: '#1877f2',
    checkBg: '#EEF4FF',
    features: [
      'landing.pricing.starterF1',
      'landing.pricing.starterF2',
      'landing.pricing.starterF3',
      'landing.pricing.starterF4',
      'landing.pricing.starterF5',
    ],
    ctaKey: 'landing.pricing.starterCta',
    ctaLink: '/signup',
    ctaBg: '#EEF4FF',
    ctaColor: '#1877f2',
    ctaBorder: '#BFDBFE',
  },
  {
    nameKey: 'landing.pricing.proName',
    price: '€10',
    period: '/ month',
    descKey: 'landing.pricing.proDesc',
    color: '#fff',
    bg: '#221C51',
    border: '#221C51',
    checkColor: '#a78bfa',
    checkBg: 'rgba(255,255,255,0.15)',
    popular: true,
    features: [
      'landing.pricing.proF1',
      'landing.pricing.proF2',
      'landing.pricing.proF3',
      'landing.pricing.proF4',
      'landing.pricing.proF5',
      'landing.pricing.proF6',
      'landing.pricing.proF7',
    ],
    ctaKey: 'landing.pricing.proCta',
    ctaLink: '/signup',
    ctaBg: '#fff',
    ctaColor: '#221C51',
    annual: '€120 / an',
  },
  {
    nameKey: 'landing.pricing.agencyName',
    price: '€15',
    period: '/ month',
    descKey: 'landing.pricing.agencyDesc',
    color: '#059669',
    bg: '#fff',
    border: '#A7F3D0',
    checkColor: '#059669',
    checkBg: '#ECFDF5',
    features: [
      'landing.pricing.agencyF1',
      'landing.pricing.agencyF2',
      'landing.pricing.agencyF3',
      'landing.pricing.agencyF4',
      'landing.pricing.agencyF5',
      'landing.pricing.agencyF6',
      'landing.pricing.agencyF7',
    ],
    ctaKey: 'landing.pricing.agencyCta',
    ctaLink: '/signup',
    ctaBg: '#ECFDF5',
    ctaColor: '#059669',
    ctaBorder: '#A7F3D0',
    annual: '€180 / an',
  },
];

const Pricing = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="pricing" ref={ref} style={{ background: 'radial-gradient(120% 80% at 50% 0%, #120E33 0%, #08061E 62%)', padding: '96px 24px', position: 'relative', overflow: 'hidden' }}>
      <div className="oba-aurora" style={{ top: '-12%', left: '14%', width: 620, height: 620, background: 'radial-gradient(circle, rgba(109,93,251,.22) 0%, transparent 68%)' }} />
      <div style={{ maxWidth: 1100, margin: '0 auto', position: 'relative', zIndex: 1 }}>

        <div style={{ textAlign: 'center', marginBottom: 56 }}>
          <span style={{ display: 'inline-block', padding: '5px 16px', borderRadius: 999, background: 'rgba(109,93,251,0.14)', border: '1px solid rgba(109,93,251,0.38)', color: '#c7bfff', fontSize: 12, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: 20 }}>
            {t('landing.pricing.badge')}
          </span>
          <h2 style={{ fontSize: 'clamp(26px,4vw,42px)', fontWeight: 800, color: '#ffffff', letterSpacing: '-0.02em', marginBottom: 12 }}>
            {t('landing.pricing.title')}
          </h2>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.62)', maxWidth: 420, margin: '0 auto' }}>
            {t('landing.pricing.sub')}
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px,1fr))', gap: 20, alignItems: 'start' }}>
          {PLANS.map((plan, i) => (
            <div key={i} style={{
              padding: '32px 28px',
              borderRadius: 20,
              background: plan.popular
                ? 'linear-gradient(160deg, rgba(79,70,229,.34), rgba(17,13,48,.96))'
                : 'linear-gradient(160deg, rgba(24,19,60,.72), rgba(11,8,32,.88))',
              border: plan.popular ? '1.5px solid rgba(139,124,255,.5)' : '1.5px solid rgba(255,255,255,0.09)',
              boxShadow: plan.popular
                ? '0 34px 80px -22px rgba(79,70,229,.5)'
                : '0 24px 60px -22px rgba(0,0,0,0.7)',
              opacity: visible ? 1 : 0,
              transform: visible ? (plan.popular ? 'scale(1.03)' : 'none') : 'translateY(28px)',
              transition: `all 0.6s ${i * 120}ms ease`,
              position: 'relative',
            }}>
              {plan.popular && (
                <div style={{
                  position: 'absolute', top: -14, left: '50%', transform: 'translateX(-50%)',
                  background: 'linear-gradient(120deg,#a78bfa,#7dd3fc)',
                  color: '#0B0824', fontSize: 11, fontWeight: 800,
                  padding: '4px 18px', borderRadius: 999,
                  letterSpacing: '0.07em', whiteSpace: 'nowrap',
                  boxShadow: '0 8px 24px rgba(139,124,255,.45)',
                  border: '1px solid #E0E4F0',
                }}>
                  {t('landing.pricing.popular')}
                </div>
              )}

              <div style={{ marginBottom: 24 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: plan.popular ? '#c7bfff' : 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: 12 }}>{t(plan.nameKey)}</div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, marginBottom: 8 }}>
                  <span style={{ fontSize: 40, fontWeight: 900, color: '#fff', letterSpacing: '-0.03em' }}>{plan.priceKey ? t(plan.priceKey) : plan.price}</span>
                  <span style={{ fontSize: 15, color: 'rgba(255,255,255,0.45)', fontWeight: 500 }}>{plan.period ? t('landing.pricing.perMonth') : ''}</span>
                </div>
                {plan.annual && (
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginBottom: 10 }}>{t('landing.pricing.orYear')} {plan.annual}</div>
                )}
                <p style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.6)', lineHeight: 1.6 }}>{t(plan.descKey)}</p>
              </div>

              <div style={{ height: 1, background: 'rgba(255,255,255,0.11)', marginBottom: 24 }} />

              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 28px', display: 'flex', flexDirection: 'column', gap: 12 }}>
                {plan.features.map((f, j) => (
                  <li key={j} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5, color: 'rgba(255,255,255,0.8)' }}>
                    <span style={{ width: 18, height: 18, borderRadius: '50%', background: 'rgba(255,255,255,0.09)', border: '1px solid rgba(255,255,255,0.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <FaCheck style={{ fontSize: 8, color: plan.popular ? '#c7bfff' : '#5eead4' }} />
                    </span>
                    {t(f)}
                  </li>
                ))}
              </ul>

              <Link to={plan.ctaLink} style={{
                display: 'block', textAlign: 'center',
                padding: '13px 24px', borderRadius: 12,
                background: plan.popular
                  ? 'linear-gradient(135deg,#6D5DFB,#4F46E5 55%,#3B82F6)'
                  : 'rgba(255,255,255,0.07)',
                border: plan.popular ? 'none' : '1px solid rgba(255,255,255,0.16)',
                color: '#fff', fontWeight: 700, fontSize: 14,
                textDecoration: 'none',
                boxShadow: plan.popular ? '0 10px 30px -6px rgba(109,93,251,.6)' : 'none',
                transition: 'all 0.2s',
              }}
                onMouseEnter={e => { e.target.style.opacity = '0.85'; e.target.style.transform = 'translateY(-1px)'; }}
                onMouseLeave={e => { e.target.style.opacity = '1'; e.target.style.transform = 'none'; }}
              >
                {t(plan.ctaKey)}
              </Link>
            </div>
          ))}
        </div>

        <p style={{ textAlign: 'center', marginTop: 32, fontSize: 13, color: 'rgba(255,255,255,0.42)' }}>
          {t('landing.pricing.note')}
        </p>
      </div>
    </section>
  );
};

export default Pricing;
